import { render } from "./AboutBody.vue?vue&type=template&id=76abbde5&scoped=true"
const script = {}

import "./AboutBody.vue?vue&type=style&index=0&id=76abbde5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76abbde5"]])

export default __exports__